"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography, Icon } from "@/shared/ui/atoms";
import { useTranslations } from "next-intl";
interface ReviewKeywordListProps {
  type: "positive" | "negative";
  keywords: {
    keyword: string;
    count: number;
  }[];
}
const ReviewKeywordList = t0 => {
  const $ = _c(21);
  const {
    type,
    keywords
  } = t0;
  const t = useTranslations();
  const color = type === "positive" ? "#6B00D71A" : "#F4F4F5";
  const icon = type === "positive" ? "/icons/positive.svg" : "/icons/negative.svg";
  let t1;
  if ($[0] !== t || $[1] !== type) {
    t1 = type === "positive" ? t("commonReview.positive") : t("commonReview.negative");
    $[0] = t;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const label = t1;
  let t2;
  if ($[3] !== icon || $[4] !== label) {
    t2 = <Icon src={icon} width={20} height={20} alt={label} />;
    $[3] = icon;
    $[4] = label;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== label) {
    t3 = <Typography size={12} className="text-[#46474C] font-medium">{label}</Typography>;
    $[6] = label;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex items-center gap-1">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== color || $[12] !== keywords) {
    let t6;
    if ($[14] !== color) {
      t6 = (item, index) => <div key={`${item.keyword}-${index}`} className="py-[6px] px-2 w-full flex items-center justify-between rounded-lg" style={{
        backgroundColor: color
      }}><Typography size={14} lineHeight="normal" className="font-medium">{item.keyword}</Typography><Typography size={12} lineHeight="normal" className="text-[#5A5C63]">{item.count.toLocaleString("ko-KR")}</Typography></div>;
      $[14] = color;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t5 = keywords.map(t6);
    $[11] = color;
    $[12] = keywords;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <div className="mt-[6px] w-full flex flex-wrap gap-[6px]">{t5}</div>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t6) {
    t7 = <div className="w-full">{t4}{t6}</div>;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default ReviewKeywordList;